export const REGULAR_FIELD_WITH_ERROR_SELECTOR = ".form-field--invalid";

export const CASCADING_FIELD_WITH_ERROR_SELECTOR = ".form-field-cascading-error";

export const SCROLL_OPTIONS = { behavior: "smooth", block: "center" };

